<style>
input[type="checkbox"][readonly] {
  pointer-events: none;
}
</style>

<template>
  <div>
    <!-- <Layout :style="{overflowY: 'scroll', marginTop: '60px'}"> -->
    <Table :styleX="{ marginTop: '100px' }" heightx="300" border :columns="columns" :data="items">
      <template slot-scope="{ row, index }" slot="action">
        <Button :type="row.online ? 'success' : 'error'" size="small" style="margin-right: 5px">{{ row.online ? "Online"
          : "Offline" }}</Button>
        <Button type="error" size="small" @click="del(row)">Delete</Button>
      </template>
    </Table>
    <!-- </Layout> -->
  </div>
</template>

<script>
var timerHandle = 0;

export default {
  methods: {
    update() {
      fetch("/api/mon.status")
        .then(resp => resp.json())
        .then(message => {
          if (message.success) {
            this.items = message.payload;
          } else {
            this.items = [];
          }
        })
        .catch(() => {
          this.items = [];
        });
    },

    del(row) {
      const id = row.ID || row.id;

      if (!id) {
        this.$Message.error("Unable remove device: invalid device ID");
        return;
      }

      this.$Modal.confirm({
        title: "Confirm Delete",
        content: `<p>This will remove ${row.name}, are you sure?</p>`,
        onOk: () => {
          fetch(`/api/mon.del?id=${encodeURIComponent(id)}`)
            .then(resp => resp.json())
            .then(message => {
              if (message.success) {
                this.$Message.info("Device successfully removed");
                this.update();
              } else {
                this.$Message.error("Unable remove device!");
              }
            })
            .catch(() => {
              this.$Message.error("Unable remove device!");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    }
  },

  created() {
    // this.reload();
  },

  mounted: function () {


    timerHandle = setInterval(() => {
      this.update();
    }, 5000);

    this.update();

    // console.log('Update interval');
  },

  destroyed() {
    //   console.log(this.unwatch);
    clearInterval(timerHandle);
    timerHandle = 0;

    // console.log('Release interval');
  },

  data() {
    return {
      items: [],
      columns: [
        {
          title: "Name",
          key: "name",
          sortable: true
        },
        {
          title: "IP Address",
          key: "ip"
        },
        {
          title: "MAC Address",
          key: "mac"
        },
        {
          title: "Last Seen",
          key: "time",
          sortable: true
        },
        // {
        //     title: " ",
        //     key: "diffStr"
        // },
        {
          title: "Status",
          key: "online",
          width: 210,
          align: "center",
          sortable: true,
          slot: "action"

          // render: (h, params) => {
          //   return h("div", [
          //     h(
          //       "Button",
          //       {
          //         props: {
          //           shape: "circle",
          //           type: params.row.online ? "success" : "error"
          //         }
          //       },
          //       params.row.online ? "Online" : "Offline"
          //     ),

          //     h(
          //       "Button",
          //       {
          //         props: {
          //           type: "error",

          //         },
          //         on: {
          //           click: () => {
          //             this.remove(params.index);
          //           }
          //         }
          //       },
          //       "Delete"
          //     )
          //   ]);
          // }
        }
      ]
    };
  }
};
</script>